/**
 * TanStack Query hooks for `real-time-reporting`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	realTimeReportingQueryKeys,
	type CreateRealTimeReportingBody,
	type ListRealTimeReportingResponse,
	type RealTimeReportingRow,
} from "./api";

export function useRealTimeReportingList(): UseQueryResult<ListRealTimeReportingResponse, Error> {
	return useQuery({
		queryKey: realTimeReportingQueryKeys.list(),
		queryFn: list,
	});
}

export function useRealTimeReportingCreate(): UseMutationResult<RealTimeReportingRow, Error, CreateRealTimeReportingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: realTimeReportingQueryKeys.all });
		},
	});
}

export function useRealTimeReportingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: realTimeReportingQueryKeys.all });
		},
	});
}
